import { tv } from "tailwind-variants";

export const sidebarItemStyles = tv({
  base: `
    flex w-full min-w-0 shrink-0 cursor-pointer items-center overflow-hidden
    rounded-lg px-3 text-base font-normal whitespace-nowrap text-text-primary
    transition-colors duration-200
    hover:bg-sidebar/20 disabled:cursor-not-allowed
    disabled:bg-tertiary/30
    disabled:opacity-50 aria-[current=page]:text-text-sidebar
  `,
  variants: {
    expanded: {
      true: "h-12 min-w-10 justify-start gap-3 px-3.5",
      false: "h-12 justify-center gap-0 px-0",
    },
    subitem: {
      false: `
        text-base
        group-has-data-expanded-true/sidebar-item-wrapper:bg-sidebar
        group-has-data-[status=active]/sidebar-item-wrapper:text-text-sidebar
        group-has-[a[aria-current="page"]]/sidebar-item-wrapper:bg-sidebar aria-[current=page]:bg-sidebar
      `,
      true: `
        hidden border-l-2 border-l-transparent pl-[46px] text-base
        text-text-secondary
        group-has-[*[data-expanded="true"]]/sidebar-item-wrapper:flex aria-[current=page]:font-bold aria-[current=page]:text-text-sidebar
      `,
    },
  },
  defaultVariants: { subitem: false },
});

export const sidebarContentStyles = tv({
  slots: {
    label: `
      min-w-0 overflow-hidden whitespace-nowrap
      transition-opacity duration-150 ease-out
    `,
    chevronWrapper: `
      overflow-hidden transition-opacity duration-150 ease-out
    `,
  },
  variants: {
    expanded: {
      true: {
        label: "max-w-40 opacity-100 delay-150",
        chevronWrapper: "ml-auto max-w-5 opacity-100 delay-200",
      },
      false: {
        label: "max-w-0 opacity-0 delay-0",
        chevronWrapper: "max-w-0 opacity-0 delay-0",
      },
    },
  },
});
